/**
 * Public Offer (Договір публічної оферти) content for SEOGeeks AI
 * Visibility.
 *
 * Modelled on the Ukrainian Civil Code (Article 634 — contracts of
 * adhesion), the Law on Electronic Commerce, and the Law on Consumer
 * Rights Protection. The Operator must complete the "Реквізити /
 * Details" block (legal name, EDRPOU / RNOKPP, bank details) before
 * publishing.
 */

const SHARED = {
  contactEmail: "ai-visibility@seogeeks.com.ua",
  lastUpdated: "2026-05-18",
  siteUrl: "https://seogeeks.com.ua/ai-visibility/",
};

export const OFFER_CONTENT = {
  uk: {
    ...SHARED,
    title: "Публічна оферта (Договір)",
    intro:
      "Цей документ є офіційною публічною пропозицією (офертою) Виконавця укласти " +
      "договір про надання доступу до онлайн-сервісу SEOGeeks AI Visibility на " +
      "умовах, викладених нижче. Реєстрація та/або оплата є акцептом цієї Оферти.",
    sections: [
      {
        title: "1. Визначення термінів",
        body: [
          "«Оферта» — публічна пропозиція укласти договір про надання доступу до Сервісу на умовах, визначених цим документом.",
          "«Акцепт» — повне і безумовне прийняття Користувачем умов Оферти шляхом реєстрації на Сайті або здійснення оплати.",
          "«Виконавець» — особа, яка надає доступ до Сервісу на законних підставах (реквізити — у розділі 15).",
          "«Користувач» (Замовник) — фізична особа або суб'єкт підприємницької діяльності, який здійснив Акцепт цієї Оферти.",
          "«Сайт» — веб-ресурс за адресою " + SHARED.siteUrl + ".",
          "«Сервіс» — онлайн-платформа SEOGeeks AI Visibility, що надає функціональні можливості відповідно до обраного тарифу.",
          "«Тариф» — встановлений Виконавцем обсяг функціональних можливостей Сервісу, строк користування та вартість доступу.",
          "«Токени» — внутрішня валюта Сервісу, що витрачається на запуск перевірок видимості у LLM-моделях.",
        ],
      },
      {
        title: "2. Загальні положення",
        body:
          "Договір є договором приєднання (ст. 634 ЦК України). Укладаючи Договір, " +
          "Користувач підтверджує повне ознайомлення з його умовами, безумовне їх " +
          "прийняття та розуміння правових наслідків. Договір укладається в електронній " +
          "формі відповідно до Закону України «Про електронну комерцію».",
      },
      {
        title: "3. Предмет договору",
        body:
          "Виконавець надає Користувачу обмежене, невиключне, непередаване та відкличне " +
          "право доступу до Сервісу за плату. Сервіс надається у поточному функціональному " +
          "стані; Виконавець вживає розумних заходів для безперервної роботи, але не " +
          "гарантує досягнення Користувачем конкретного комерційного результату.",
      },
      {
        title: "4. Порядок надання послуг",
        body:
          "Доступ активується після зарахування коштів на рахунок Виконавця та технічної " +
          "активації відповідного функціоналу. Послуга вважається наданою належним чином з " +
          "моменту надання технічної можливості користування Сервісом. Окремі акти " +
          "приймання-передачі не оформлюються.",
      },
      {
        title: "5. Вартість та порядок оплати",
        body:
          "Вартість визначається обраним Тарифом і зазначається на Сайті на момент оплати. " +
          "Оплата здійснюється у безготівковій формі через платіжний сервіс WayForPay. " +
          "Обов'язок з оплати вважається виконаним з моменту зарахування коштів на рахунок " +
          "Виконавця. Розрахунковий документ (фіскальний чек) формується програмним РРО та " +
          "надається Користувачу в електронному вигляді.",
      },
      {
        title: "6. Права та обов'язки сторін",
        body: [
          "Виконавець має право: змінювати умови Тарифів з повідомленням на Сайті; призупиняти доступ при невиконанні Користувачем грошових зобов'язань; залучати третіх осіб (хостинг, платіжний шлюз, LLM-постачальники) для надання Сервісу.",
          "Виконавець зобов'язаний: надавати доступ відповідно до Тарифу; забезпечити захист персональних даних; вживати заходів для безперебійної роботи Сервісу.",
          "Користувач має право: отримувати доступ до оплачених функцій; отримувати роз'яснення щодо роботи Сервісу; на захист персональних даних.",
          "Користувач зобов'язаний: своєчасно сплачувати вартість обраного Тарифу; не порушувати умови використання; повідомляти Виконавця про зміну своїх контактних реквізитів.",
        ],
      },
      {
        title: "7. Повернення коштів",
        body:
          "Сплачені кошти не підлягають поверненню після надання доступу до Сервісу, за " +
          "винятком таких випадків: технічна несправність Виконавця, що унеможливила надання " +
          "Сервісу протягом понад 24 годин поспіль; припинення роботи Сервісу Виконавцем до " +
          "закінчення оплаченого періоду (пропорційне повернення). Заяву на повернення " +
          "надсилають на " + SHARED.contactEmail + "; повернення здійснюється протягом 10 " +
          "робочих днів з моменту погодження.",
      },
      {
        title: "8. Відповідальність сторін",
        body:
          "Виконавець відповідає лише за належне надання доступу до Сервісу. Виконавець не " +
          "несе відповідальності за: точність відповідей LLM-моделей третіх сторін; результати, " +
          "досягнуті або не досягнуті Користувачем у процесі використання Сервісу; перебої з " +
          "причин, що не залежать від Виконавця. Максимальна відповідальність Виконавця " +
          "обмежується сумою, сплаченою Користувачем за останній оплачений період.",
      },
      {
        title: "9. Персональні дані",
        body:
          "Обробка персональних даних здійснюється відповідно до Закону України «Про захист " +
          "персональних даних» та Політики конфіденційності Сервісу, що є невід'ємним додатком " +
          "до цього Договору.",
      },
      {
        title: "10. Блокування та припинення доступу",
        body:
          "Виконавець має право призупинити або припинити доступ у разі: прострочення оплати; " +
          "порушення умов Договору; підозри в шахрайській активності; технічного обслуговування. " +
          "Користувача повідомляють на email, зазначений при реєстрації.",
      },
      {
        title: "11. Строк дії договору",
        body:
          "Договір набирає чинності з моменту Акцепту та діє протягом оплаченого періоду " +
          "доступу. Для тарифів з підпискою Договір автоматично продовжується на наступний " +
          "розрахунковий період за умови успішного списання коштів.",
      },
      {
        title: "12. Форс-мажор",
        body:
          "Сторони звільняються від відповідальності у разі настання обставин непереборної " +
          "сили: стихійні лиха, війна, терористичні дії, рішення державних органів, відключення " +
          "магістрального інтернету або електропостачання. Якщо форс-мажор триває понад 30 " +
          "днів, будь-яка зі Сторін має право розірвати Договір без штрафних санкцій.",
      },
      {
        title: "13. Зміни умов Договору",
        body:
          "Виконавець має право вносити зміни до Оферти, публікуючи нову редакцію на Сайті. " +
          "Зміни набирають чинності через 7 календарних днів після публікації. Продовження " +
          "користування Сервісом після цього строку означає Акцепт нової редакції.",
      },
      {
        title: "14. Застосовне право та вирішення спорів",
        body:
          "Договір регулюється правом України. Сторони намагаються вирішити спір шляхом " +
          "переговорів протягом 10 робочих днів. У разі недосягнення згоди спір передається " +
          "на розгляд суду за місцезнаходженням Виконавця.",
      },
      {
        title: "15. Реквізити Виконавця",
        body:
          "Повні реквізити Виконавця (повне найменування, РНОКПП / ЄДРПОУ, банківські " +
          "реквізити, контактна адреса) надаються за запитом на " + SHARED.contactEmail +
          " та зазначаються у фіскальному чеку, що формується після оплати.",
      },
    ],
  },

  ru: {
    ...SHARED,
    title: "Публичная оферта (Договор)",
    intro:
      "Настоящий документ является официальным публичным предложением (офертой) " +
      "Исполнителя заключить договор о предоставлении доступа к онлайн-сервису " +
      "SEOGeeks AI Visibility на изложенных ниже условиях. Регистрация и/или " +
      "оплата являются акцептом настоящей Оферты.",
    sections: [
      {
        title: "1. Определения терминов",
        body: [
          "«Оферта» — публичное предложение заключить договор о предоставлении доступа к Сервису.",
          "«Акцепт» — полное и безусловное принятие условий Оферты путём регистрации или оплаты.",
          "«Исполнитель» — лицо, предоставляющее доступ к Сервису на законных основаниях (реквизиты — раздел 15).",
          "«Пользователь» (Заказчик) — физическое лицо или субъект предпринимательской деятельности, осуществивший Акцепт.",
          "«Сайт» — веб-ресурс по адресу " + SHARED.siteUrl + ".",
          "«Сервис» — онлайн-платформа SEOGeeks AI Visibility, предоставляющая функциональность по выбранному тарифу.",
          "«Тариф» — установленный Исполнителем объём функциональных возможностей Сервиса, срок и стоимость доступа.",
          "«Токены» — внутренняя валюта Сервиса, расходуемая на запуск проверок видимости в LLM-моделях.",
        ],
      },
      {
        title: "2. Общие положения",
        body:
          "Договор является договором присоединения (ст. 634 ГК Украины). Заключая Договор, " +
          "Пользователь подтверждает полное ознакомление с его условиями, безусловное их " +
          "принятие и понимание правовых последствий. Договор заключается в электронной форме " +
          "в соответствии с Законом Украины «Об электронной коммерции».",
      },
      {
        title: "3. Предмет договора",
        body:
          "Исполнитель предоставляет Пользователю ограниченное, неисключительное, " +
          "непередаваемое и отзывное право доступа к Сервису за плату. Сервис предоставляется " +
          "в текущем функциональном состоянии; Исполнитель прилагает разумные усилия для " +
          "непрерывной работы, но не гарантирует достижение Пользователем конкретного " +
          "коммерческого результата.",
      },
      {
        title: "4. Порядок оказания услуг",
        body:
          "Доступ активируется после поступления средств на счёт Исполнителя и технической " +
          "активации функционала. Услуга считается оказанной надлежащим образом с момента " +
          "предоставления технической возможности пользования. Отдельные акты приёма-передачи " +
          "не оформляются.",
      },
      {
        title: "5. Стоимость и порядок оплаты",
        body:
          "Стоимость определяется выбранным Тарифом и указана на Сайте на момент оплаты. " +
          "Оплата осуществляется в безналичной форме через платёжный сервис WayForPay. " +
          "Обязательство по оплате считается выполненным с момента зачисления средств на " +
          "счёт Исполнителя. Расчётный документ (фискальный чек) формируется программным РРО " +
          "и предоставляется Пользователю в электронном виде.",
      },
      {
        title: "6. Права и обязанности сторон",
        body: [
          "Исполнитель вправе: изменять условия Тарифов с уведомлением на Сайте; приостанавливать доступ при невыполнении Пользователем денежных обязательств; привлекать третьих лиц (хостинг, платёжный шлюз, LLM-поставщики) для предоставления Сервиса.",
          "Исполнитель обязан: предоставлять доступ согласно Тарифу; обеспечить защиту персональных данных; принимать меры для бесперебойной работы Сервиса.",
          "Пользователь вправе: получать доступ к оплаченным функциям; получать разъяснения по работе Сервиса; на защиту персональных данных.",
          "Пользователь обязан: своевременно оплачивать стоимость выбранного Тарифа; не нарушать условия использования; уведомлять Исполнителя об изменении контактных данных.",
        ],
      },
      {
        title: "7. Возврат средств",
        body:
          "Уплаченные средства не подлежат возврату после предоставления доступа к Сервису, " +
          "за исключением: технической неисправности Исполнителя, делающей Сервис " +
          "недоступным более 24 часов подряд; прекращения работы Сервиса до окончания " +
          "оплаченного периода (пропорциональный возврат). Заявку на возврат направляют " +
          "на " + SHARED.contactEmail + "; возврат осуществляется в течение 10 рабочих дней " +
          "с момента согласования.",
      },
      {
        title: "8. Ответственность сторон",
        body:
          "Исполнитель отвечает только за надлежащее предоставление доступа к Сервису. " +
          "Исполнитель не несёт ответственности за: точность ответов сторонних LLM-моделей; " +
          "результаты, достигнутые или не достигнутые Пользователем; перебои по причинам, не " +
          "зависящим от Исполнителя. Максимальная ответственность Исполнителя ограничивается " +
          "суммой, уплаченной Пользователем за последний оплаченный период.",
      },
      {
        title: "9. Персональные данные",
        body:
          "Обработка персональных данных осуществляется в соответствии с Законом Украины " +
          "«О защите персональных данных» и Политикой конфиденциальности Сервиса, " +
          "являющейся неотъемлемым приложением к настоящему Договору.",
      },
      {
        title: "10. Блокировка и прекращение доступа",
        body:
          "Исполнитель вправе приостановить или прекратить доступ в случае: просрочки оплаты; " +
          "нарушения условий Договора; подозрения в мошеннической активности; технического " +
          "обслуживания. Пользователь уведомляется по email, указанному при регистрации.",
      },
      {
        title: "11. Срок действия договора",
        body:
          "Договор вступает в силу с момента Акцепта и действует в течение оплаченного " +
          "периода доступа. Для тарифов с подпиской Договор автоматически продлевается на " +
          "следующий расчётный период при успешном списании средств.",
      },
      {
        title: "12. Форс-мажор",
        body:
          "Стороны освобождаются от ответственности при наступлении обстоятельств " +
          "непреодолимой силы: стихийные бедствия, война, террористические действия, решения " +
          "государственных органов, отключения магистрального интернета или электроснабжения. " +
          "Если форс-мажор длится более 30 дней, любая из Сторон вправе расторгнуть Договор " +
          "без штрафных санкций.",
      },
      {
        title: "13. Изменение условий Договора",
        body:
          "Исполнитель вправе вносить изменения в Оферту, публикуя новую редакцию на Сайте. " +
          "Изменения вступают в силу через 7 календарных дней после публикации. Продолжение " +
          "использования Сервиса после этого срока означает Акцепт новой редакции.",
      },
      {
        title: "14. Применимое право и разрешение споров",
        body:
          "Договор регулируется правом Украины. Стороны стараются разрешить спор путём " +
          "переговоров в течение 10 рабочих дней. При недостижении согласия спор передаётся " +
          "в суд по местонахождению Исполнителя.",
      },
      {
        title: "15. Реквизиты Исполнителя",
        body:
          "Полные реквизиты Исполнителя (полное наименование, РНОКПП / ЕГРПОУ, банковские " +
          "реквизиты, контактный адрес) предоставляются по запросу на " + SHARED.contactEmail +
          " и указываются в фискальном чеке, формируемом после оплаты.",
      },
    ],
  },

  en: {
    ...SHARED,
    title: "Public Offer Agreement",
    intro:
      "This document is the Operator's public offer to conclude a contract for " +
      "access to the SEOGeeks AI Visibility online service on the terms below. " +
      "Registering and/or paying constitutes acceptance of this Offer.",
    sections: [
      {
        title: "1. Definitions",
        body: [
          "“Offer” — a public proposal to conclude a contract for access to the Service.",
          "“Acceptance” — full and unconditional acceptance of the Offer by registration or payment.",
          "“Operator” — the entity providing the Service on a lawful basis (details — section 15).",
          "“User” — a natural person or business entity that has accepted the Offer.",
          "“Site” — the web resource at " + SHARED.siteUrl + ".",
          "“Service” — the SEOGeeks AI Visibility online platform providing functionality per the chosen Plan.",
          "“Plan” — the scope of features, term and price of access set by the Operator.",
          "“Tokens” — the Service's internal credits spent on visibility checks against LLMs.",
        ],
      },
      {
        title: "2. General provisions",
        body:
          "This contract is a contract of adhesion (Art. 634 of the Civil Code of Ukraine). " +
          "By accepting, the User confirms full familiarity with its terms, unconditional " +
          "acceptance, and understanding of the legal consequences. The contract is concluded " +
          "electronically per the Law of Ukraine “On Electronic Commerce”.",
      },
      {
        title: "3. Subject",
        body:
          "The Operator grants the User a limited, non-exclusive, non-transferable and " +
          "revocable right to access the Service for a fee. The Service is provided as-is; " +
          "the Operator makes reasonable efforts to keep it running but does not guarantee " +
          "any specific commercial result for the User.",
      },
      {
        title: "4. Service delivery",
        body:
          "Access is activated once payment is received and the relevant functionality is " +
          "technically enabled. The service is deemed properly rendered upon provision of " +
          "technical access. No separate acts of acceptance are signed.",
      },
      {
        title: "5. Price and payment",
        body:
          "The price is set by the chosen Plan and shown on the Site at the time of payment. " +
          "Payment is made cashlessly via the WayForPay payment gateway. Payment is deemed " +
          "complete upon credit to the Operator's account. A fiscal receipt is generated by " +
          "the software cash register and provided electronically.",
      },
      {
        title: "6. Rights and obligations",
        body: [
          "Operator may: change Plan terms with notice on the Site; suspend access for unpaid fees; engage third parties (hosting, payment gateway, LLM providers) to deliver the Service.",
          "Operator must: provide access per the Plan; protect personal data; take reasonable measures for continuous operation.",
          "User may: access paid features; receive explanations about the Service; have their personal data protected.",
          "User must: pay the Plan price on time; comply with these Terms; notify the Operator of changes to contact details.",
        ],
      },
      {
        title: "7. Refunds",
        body:
          "Paid amounts are non-refundable once access has been granted, except: technical " +
          "failures by the Operator that make the Service unavailable for more than 24 " +
          "consecutive hours; discontinuation of the Service by the Operator before the paid " +
          "period ends (pro-rata refund). Refund requests are sent to " + SHARED.contactEmail +
          "; refunds are processed within 10 business days of approval.",
      },
      {
        title: "8. Liability",
        body:
          "The Operator is liable only for proper provision of access to the Service. The " +
          "Operator is not liable for: the accuracy of third-party LLM responses; results " +
          "achieved or not achieved by the User; interruptions caused by factors outside the " +
          "Operator's control. Maximum liability is capped at the amount paid by the User for " +
          "the last billing period.",
      },
      {
        title: "9. Personal data",
        body:
          "Personal data processing is governed by the Law of Ukraine “On Personal Data " +
          "Protection” and the Service's Privacy Policy, which is an integral attachment to " +
          "this contract.",
      },
      {
        title: "10. Suspension and termination",
        body:
          "The Operator may suspend or terminate access in case of: payment default; breach " +
          "of contract; suspected fraud; planned maintenance. The User is notified by email " +
          "registered to the account.",
      },
      {
        title: "11. Term",
        body:
          "The contract takes effect from Acceptance and remains in force for the paid period. " +
          "Subscription Plans renew automatically for the next billing period upon successful " +
          "payment.",
      },
      {
        title: "12. Force majeure",
        body:
          "The parties are released from liability in case of force majeure: natural " +
          "disasters, war, terrorism, government acts, mains internet or power outages. If " +
          "force majeure lasts more than 30 days, either party may terminate the contract " +
          "without penalty.",
      },
      {
        title: "13. Changes to the contract",
        body:
          "The Operator may amend the Offer by publishing a new version on the Site. Changes " +
          "take effect 7 calendar days after publication. Continued use after that period " +
          "constitutes Acceptance of the new version.",
      },
      {
        title: "14. Governing law and disputes",
        body:
          "The contract is governed by the law of Ukraine. The parties first try to resolve " +
          "disputes by negotiation within 10 business days; failing that, the dispute goes to " +
          "the courts at the Operator's seat.",
      },
      {
        title: "15. Operator details",
        body:
          "Full operator details (registered name, RNOKPP/EDRPOU, bank details, contact " +
          "address) are available on request at " + SHARED.contactEmail + " and are included " +
          "in the fiscal receipt issued after payment.",
      },
    ],
  },
};
